import { buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const CASE_SECURITY_BASE_PATH = '/CaseSecurity';

export const caseSecurityEndpoints = {
  byCase:       (caseId: ID) => buildEndpointWithParams(`${CASE_SECURITY_BASE_PATH}/by-case/:caseId`,           { caseId }),
  inScope:      (caseId: ID) => buildEndpointWithParams(`${CASE_SECURITY_BASE_PATH}/by-case/:caseId/in-scope`,  { caseId }),
  updateScope:  (id: ID)     => buildEndpointWithParams(`${CASE_SECURITY_BASE_PATH}/:id/scope`,                 { id }),
  setPrimary:   (id: ID)     => buildEndpointWithParams(`${CASE_SECURITY_BASE_PATH}/:id/primary`,               { id }),
} as const;
